import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=942f65b8&scoped=true&"
import script from "./Structure.vue?vue&type=script&lang=js&"
export * from "./Structure.vue?vue&type=script&lang=js&"
import style0 from "./Structure.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Structure.vue?vue&type=style&index=1&id=942f65b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942f65b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon,VSheet})
